import React from 'react'
import { FORM_ERROR } from 'final-form'
import PropTypes from 'prop-types'
import { segment, track } from '@mc/track-event'
import { useSignUpEducation } from '../../experiments/ce-3448-clarify-multiple-profiles-at-sign-up/hooks/useSignUpEducation'
import {
  signUp,
  redirect,
  fbAuth,
  isSuccessful,
  needsConfirmation,
} from '../../services'
import { isGiftAccountClarificationOn } from '../../utils'
import GiftRegisterForm from './GiftRegisterForm'
import RegisterForm from './RegisterForm'

const RegisterFormContainer = (props) => {
  const { isExperimentParticipant: isSignUpEducationExperimentParticipant } =
    useSignUpEducation()
  const handleSubmit = async (values) => {
    const { nextPage, afterAuthAction, onLogIn } = props
    try {
      track(segment.EventTypes.SIGN_UP_MODAL_CTA_CLICKED, {
        signup_method: 'email',
      })
      const res = await signUp({ ...values, nextPage })

      if (!isSignUpEducationExperimentParticipant) {
        track(segment.EventTypes.SIGNED_UP, {
          auth: 'email',
        })
      }

      if (afterAuthAction) {
        afterAuthAction(res)
      }
      redirect(res, onLogIn)
      return {}
    } catch (error) {
      if (error.email) {
        return { [FORM_ERROR]: 'That email has already been taken' }
      } else if (error.password) {
        return { [FORM_ERROR]: `Password ${error.password[0]}` }
      }
      return { [FORM_ERROR]: error }
    }
  }

  const handleFacebookResponse = (res) => {
    const { onLogIn, afterAuthAction, onConfirmationRequired } = props
    if (isSuccessful(res)) {
      if (afterAuthAction) {
        afterAuthAction(res, 'facebook')
      }

      redirect(res, onLogIn)
    } else if (needsConfirmation(res)) {
      onConfirmationRequired(res)
    }
  }

  const facebookSignUp = async () => {
    try {
      const res = await fbAuth()
      handleFacebookResponse(res)
      return {}
    } catch (error) {
      return { [FORM_ERROR]: error }
    }
  }

  return isGiftAccountClarificationOn() ? (
    <GiftRegisterForm
      onSubmit={handleSubmit}
      facebookSignUp={facebookSignUp}
      {...props}
    />
  ) : (
    <RegisterForm
      onSubmit={handleSubmit}
      facebookSignUp={facebookSignUp}
      {...props}
    />
  )
}

RegisterFormContainer.propTypes = {
  afterAuthAction: PropTypes.func,
  onConfirmationRequired: PropTypes.func.isRequired,
  onLogIn: PropTypes.func,
  nextPage: PropTypes.string,
}

export default RegisterFormContainer
